<template>
    <div class="container mx-auto mt-8 mb-4">
        <router-link :to="{ name: 'LandingPage' }">
            <button
                class="text-xs md:text-xl text-gray-800 font-semibold py-2 px-4 flex items-center space-x-2 no-shadow border-none bg-transparent"
            >
                <img class="inline-block h-2 w-2" src="@/assets/img/left_arrow.svg" />
                <span>Return to case studies</span>
            </button>
        </router-link>
    </div>

    <div
        ref="banner"
        class="py-6 px-4"
        :style="{
            background: `
                ${study.bannerGradient || 'linear-gradient(0deg, rgba(10, 50, 84, 0.70) 0%, rgba(10, 50, 84, 0.70) 100%)'},
                url(${studyBanner}) no-repeat top center / cover`,
        }"
    >
        <div class="container mx-auto flex gap-x-3 items-start">
            <img :src="study.titleIcon" :alt="study.titleIconAlt" class="w-14 h-auto" />

            <div class="flex-grow">
                <h1 class="text-2xl md:text-5xl font-semibold text-white mb-3">{{ study.title }}</h1>
                <h3 class="text-base md:text-2xl  text-white">{{ study.subPageSubtitle }}</h3>
            </div>
        </div>
    </div>

    <NavigatorComponent :sections="sections" />

    <div
        v-for="(section, index) in sections"
        :key="index"
        :data-index="index"
        :class="[index % 2 === 0 ? 'bg-white' : 'bg-grey']"
        class="case-study-section py-12 px-4"
    >
        <div class="container mx-auto">
            <SubPageSection :section="section" />
        </div>
    </div>
</template>

<script setup>
import { useMeta } from 'vue-meta';
import { computed, onMounted } from 'vue';
import NavigatorComponent from '@/components/NavigatorComponent.vue';
import SubPageSection from '@/components/SubPageSection.vue';
import { studies } from '@/content/studies';
import studyBanner from '@/assets/img/study-banner.jpg';
import { useRoute } from 'vue-router';

const route = useRoute();

const studyId = computed(() => route.params.studyId);

const study = computed(() => studies[studyId.value]);
const sections = computed(() => study.value.sections);

onMounted(() => {
    useMeta({
        // title: 'Case Study Explorer',
        description: study.value.meta?.description,
        og: {
            title: study.value.meta?.title,
            description: study.value.meta?.description,
            url: window.location.href,
            image: `${window.location.origin}/assets/logo.png`,
        },
        // meta: [
        //     { name: 'description', content: study.value.meta?.description },
        //     { name: 'og:title', content: study.value.meta?.title },
        //     { name: 'og:description', content: study.value.meta?.description },
        //     { name: 'og:image', content: `${window.location.origin}/assets/logo.png` },
        //     { name: 'og:url', content: window.location.href },
        // ]
    });
})
</script>

<style scoped></style>
